import { Link } from '@mui/material';
import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { getSessionVersionToken } from '@ui-framework/index';

export const LOGO_TYPE = {
  FULL: 'FULL',
  COMPACT: 'COMPACT',
};

function Logo({
  href = null,
  target = '',
  size = 'large',
  type = LOGO_TYPE.FULL,
  imgProps = {},
  ...props
}) {
  let width = type === LOGO_TYPE.FULL ? 250 : 75;

  if (type === LOGO_TYPE.FULL && size === 'medium') {
    width = 170;
  } else if (type === LOGO_TYPE.FULL && size === 'small') {
    width = 150;
  } else if (type === LOGO_TYPE.COMPACT && size === 'medium') {
    width = 40;
  } else if (type === LOGO_TYPE.COMPACT && size === 'small') {
    width = 20;
  }

  const sessionVersion = getSessionVersionToken();
  // the theme is the source of truth for mode: on public pages (login, legal,
  // help) the dark theme never applies even when the user's stored mode is dark
  const { palette } = useTheme();
  const fullLogo = palette.mode === 'dark' ? 'logodark' : 'logo';
  const compactDarkSrc = `/mobilelogodark.png?v=${sessionVersion}`;
  const [failedCompactDarkSrc, setFailedCompactDarkSrc] = useState(null);
  const compactSrc =
    palette.mode === 'dark' && failedCompactDarkSrc !== compactDarkSrc
      ? compactDarkSrc
      : `/mobilelogo.png?v=${sessionVersion}`;

  const Img = (
    <img
      width={width}
      alt="Logo"
      src={
        type === LOGO_TYPE.FULL
          ? `/${fullLogo}.png?v=${sessionVersion}`
          : compactSrc
      }
      {...imgProps}
      onError={event => {
        // Dark compact assets are optional in each client's branding folder.
        if (
          imgProps.src === undefined &&
          type === LOGO_TYPE.COMPACT &&
          event.currentTarget.getAttribute('src') === compactDarkSrc
        ) {
          setFailedCompactDarkSrc(compactDarkSrc);
        }
        imgProps.onError?.(event);
      }}
    />
  );

  if (href) {
    return (
      <Link href={href} {...(target !== '' && { target })} {...props}>
        {Img}
      </Link>
    );
  }
  return Img;
}

export default Logo;
